export default "__VITE_ASSET__D_K1l5F$__"